import { ApiRoutes } from "../networking/apiRoutes";

/**
 * Defines pagination options.
 */
export type PaginationPayload = {
	page: number;
	pageSize: number;
};

export enum GetOptionsTopic {
	Countries = "countries",
	NodeTypes = "node-types",
	Roles = "roles",
	NodeActivities = "node-activities",
	MeasureUnits = "measure-units",
	ValueAddedServices = "value-added-services",
	ComputeFlags = "compute-flags",
	Certifications = "building-certifications",
	Sectors = "commodity-sectors",
	RefrigerationTypes = "refrigeration-type",
	TransportModes = "transport-mode",
}

export enum GetOptionsContext {
	GoodFlow = "goods-flow",
	Fuels = "fuels",
	Weight = "weight",
}

export type ResourceId = number | string;

/**
 * Defines a resource URI path and query string arguments.
 */
export type ResourceUriArgs = {
	/**
	 * The key-value map defining path components of the resource (or list of resources).
	 */
	path?: Record<string, string | number | boolean>;

	/**
	 * The key-value map defining query components of the resource (or list of resources).
	 */
	query?: Record<string, string | number | boolean>;
};

export type ResourceUri = ResourceUriArgs & {
	route: ApiRoutes;
	resourceId?: ResourceId;
};

export const uriHasResourceId = (uri: ResourceUri): boolean => {
	if (!uri.resourceId) {
		return false;
	}

	return uri.resourceId !== 0 && uri.resourceId !== "";
};
